var config = {
  api_url: 'http://localhost:3001/api/v1/'
  // api_url: 'https://api-staging.betterspaces.com/api/v1/'
}

// var env = process.env.NODE_ENV === 'production' ? 'production' : process.env.REACT_APP_ENV
var env = process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : process.env.NODE_ENV

console.log('REACT_APP_ENV: ' + process.env.REACT_APP_ENV)
console.log('LOADING CONFIG FOR ENV: ' + env)

switch (env) {
  case 'jenkins':
    break
  case 'production':
    config.api_url = 'https://api.betterspaces.com/api/v1/'
    config.raygun_api_key = 'u0sHRj/wUgXPFwmCsYBykQ=='
    config.google = {
      app_id: '378305061591-occsjuejehqvacr1e6mu1m52j1h9sro4.apps.googleusercontent.com'
    }
    config.facebook = {
      app_id: '298043990603623'
    }
    config.instagram = {
      app_id: '3f492f7dfe2a4c4ea8afd832ed75ec1d',
      redirect_url: 'http://192.168.1.97:3001/instagram_token'
    }

    config.linkedin = {
      client_id: '78io7k23ef29hy',
      redirect_url: 'http://localhost:3002/auth/callback',
      client_secret: 'pGMPcGlUqzcWt6fX'
    }
    break
  case 'development':
    config.google = {
      app_id: '378305061591-c18ljlqoetmh6f92mcia59hdfb2clg30.apps.googleusercontent.com'
    }
    config.facebook = {
      // app_id: '1813334898968764'
      app_id: '433509487150874'
    }
    config.instagram = {
      app_id: '3f492f7dfe2a4c4ea8afd832ed75ec1d',
      redirect_url: 'http://192.168.1.97:3001/instagram_token'
    }

    config.linkedin = {
      client_id: '78io7k23ef29hy',
      redirect_url: 'http://localhost:3002/auth/callback',
      client_secret: 'pGMPcGlUqzcWt6fX'
    }

    break
  case 'staging':
    config.api_url = 'https://api-staging.betterspaces.com/api/v1/'
    config.raygun_api_key = 'NwIlGw9coJ8bcyNvWGS9PQ=='
    config.google = {
      app_id: '378305061591-b52av2q8nq8ir8qafnb4kju79aa0ng2r.apps.googleusercontent.com'
    }
    config.facebook = {
      // app_id: '1813334898968764'
      app_id: '1011514969008358'
    }
    config.instagram = {
      // app_id: '512c136695ab436daee4cb8f63a077c8	'
      app_id: '3f492f7dfe2a4c4ea8afd832ed75ec1d',
      redirect_url: 'http://192.168.1.97:3001/instagram_token'
    }

    config.linkedin = {
      client_id: '78io7k23ef29hy',
      redirect_url: 'http://localhost:3002/auth/callback',
      client_secret: 'pGMPcGlUqzcWt6fX'
    }

    break
  case 'test':
  default:
    break
}

export default config



// WEBPACK FOOTER //
// ./src/config.js